// App.js
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Management from "./components/Management";
import Staff from "./components/Staff";
import LiveEvent from "./components/Liveevent";
import EkanayakeProfile from "./components/EkanayakeProfile";
import Member3Profile from "./components/Member3Profile";
import Member4Profile from "./components/Member4Profile";
import WelcomePage from "./components/WelcomePage";
import BookingForm from "./components/BookingForm";
import "./styles/main.css";
import AdminRequests from "./components/AdminPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"                        element={<Home />} />
        <Route path="/management"              element={<Management />} />
        <Route path="/staff"                   element={<Staff />} />
        <Route path="/liveevent"               element={<LiveEvent />} />
        <Route path="/staff/ekanayake"         element={<EkanayakeProfile />} />
        <Route path="/staff/nugaliyadda"       element={<Member3Profile />} />
        <Route path="/staff/senevirathne"       element={<Member4Profile />} />
        <Route path="/welcome"                 element={<WelcomePage />} />
        <Route path="/book"                 element={<BookingForm />} />
        <Route path="/admin"                 element={<AdminRequests />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;